import { render, staticRenderFns } from "./ChangeBank.vue?vue&type=template&id=ebf3f364"
import script from "./ChangeBank.vue?vue&type=script&lang=js"
export * from "./ChangeBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports